export default __webpack_public_path__ + "static/BZ_COBERTURADC_EP_R00-1_Pgina_05-32793e549dca832f02c0972546af35c0.jpg";